import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { KeyRound, Loader2, CheckCircle2 } from "lucide-react";

export default function Activar() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [state, setState] = useState("checking");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setState("invalid"); setError("Falta el enlace de activación"); return; }
    api.get(`/auth/setup-token/${token}`)
      .then((r) => { setEmail(r.data.email); setState("ready"); })
      .catch((e) => { setState("invalid"); setError(formatApiErrorDetail(e.response?.data?.detail) || "Enlace no válido"); });
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== repeat) { setError("Las contraseñas no coinciden"); return; }
    setState("saving"); setError("");
    try {
      await api.post("/auth/set-password", { token, password });
      setState("done");
      window.location.href = "/";
    } catch (e2) {
      setState("ready");
      setError(formatApiErrorDetail(e2.response?.data?.detail) || "No se pudo guardar la contraseña");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="activar-page">
      <div className="card p-8 w-full max-w-md">
        <div className="h-11 w-11 rounded-lg bg-slate-900 text-white flex items-center justify-center mb-4">
          <KeyRound size={20} />
        </div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight mb-1">Crea tu contraseña</h1>

        {state === "checking" && <p className="text-slate-500 flex items-center gap-2 mt-4"><Loader2 size={16} className="animate-spin" /> Comprobando el enlace…</p>}

        {state === "invalid" && (
          <>
            <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2 mt-3" data-testid="activar-error">{error}</p>
            <button className="btn btn-outline mt-4" onClick={() => navigate("/login")}>Ir al acceso</button>
          </>
        )}

        {state === "done" && (
          <p className="text-sm text-emerald-800 bg-emerald-50 border border-emerald-200 rounded px-3 py-2 mt-3 flex items-center gap-2" data-testid="activar-ok">
            <CheckCircle2 size={16} /> Contraseña creada. Entrando…
          </p>
        )}

        {(state === "ready" || state === "saving") && (
          <form onSubmit={submit} className="space-y-3 mt-4">
            <p className="text-slate-600 text-sm">Cuenta: <span className="font-semibold">{email}</span></p>
            <input className="input" type="password" required minLength={8} placeholder="Nueva contraseña"
                   value={password} onChange={(e) => setPassword(e.target.value)} data-testid="activar-password-input" />
            <input className="input" type="password" required minLength={8} placeholder="Repite la contraseña"
                   value={repeat} onChange={(e) => setRepeat(e.target.value)} data-testid="activar-repeat-input" />
            {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2" data-testid="activar-error">{error}</div>}
            <button type="submit" disabled={state === "saving"} className="btn btn-primary w-full" data-testid="activar-submit">
              {state === "saving" ? <><Loader2 size={15} className="animate-spin" /> Guardando…</> : "Guardar y entrar"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
